import { withSliderPortal } from '../hoc/withPortal';

const StatusBarSlider = ({ ...rest}) => {
  return withSliderPortal(<div {...rest}/>);
};

export default StatusBarSlider;
